export enum ImageSize {
  Size72 = '72',
  Size437 = '437',
  Size560 = '560',
  Size874 = '874',
  Size1120 = '1120',
}
